import { render } from "./blog-list-item.vue?vue&type=template&id=f38d9194"
import script from "./blog-list-item.vue?vue&type=script&lang=js"
export * from "./blog-list-item.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__